import { FunctionComponent, DetailedHTMLProps, HTMLAttributes } from 'react';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './insurance-box.styles';
import { formatPrice } from '../../shared/formatters/format-price';

type InsuranceBoxProps = {
    /** Chose an icon like "car" or "sofa" from our icon-list: https://flos.webplatform-hybridapps-staging-01.topdanmark.cloud/icons/development/index.html */
    iconshape: string;

    /** conifgure the size of the icon */
    iconsize: string;

    /** Title of the box (left side) */
    title: string;

    /** Description of the product - below the title */
    textline1: string;

    /** Further description of the product - below textLine1 */
    textline2?: string;

    /** Price of the product (right side) */
    price: string;

    /** Describe if the price is annually, monthly or other */
    priceformula: string;

    /** Allow custom classes */
    className?: string;
} & DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;

const InsuranceBox: FunctionComponent<InsuranceBoxProps> = (props): JSX.Element => {
    const classes = useStyles();

    return (
        <article {...props} className={`${classes.main} ${props?.className ? props?.className : ''}`}>
            <div className={classes.iconWrapper}>
                <flos-icon shape={props.iconshape} size={props.iconsize} />
            </div>
            <div className={classes.sectionLeft} color="textPrimary">
                <Typography variant="h4" className={classes.boldHeader}>
                    {props.title}
                </Typography>
                <Typography className={classes.small}>{props.textline1}</Typography>
                {props.textline2 && <Typography className={classes.small}>{props.textline2}</Typography>}
            </div>
            <div className={classes.sectionRight} color="textPrimary">
                <div className={classes.priceWrapper}>
                    <Typography variant="h4" className={classes.boldHeader}>
                        {formatPrice(props.price)}
                        <span className={classes.small}>{props.priceformula}</span>
                    </Typography>
                </div>
            </div>
        </article>
    );
};

export { InsuranceBox };
export type { InsuranceBoxProps };
